import { UNSTABLE_ToastQueue as ToastQueue } from 'react-aria-components';
import type { ToastProps } from './types';

export const NotificationsQueue = new ToastQueue<ToastProps>({ maxVisibleToasts: 1 });
